import { SpaceMd, ColorWhite } from "@nxt-costco-com/forge-design-tokens";
const containerStyles = {
  "& p": {
    margin: 0
  },
  alignItems: "stretch",
  background: ColorWhite,
  display: "flex",
  flexDirection: "column",
  gap: SpaceMd,
  height: "100%",
  justifyContent: "space-between",
  position: "relative"
};
const linkWrapperStyles = {
  "&:focus-visible": {
    borderRadius: "1px",
    outline: "2px solid -webkit-focus-ring-color",
    outlineOffset: "2px"
  },
  height: "100%",
  position: "absolute",
  width: "100%",
  zIndex: 1
};
const childElementStyles = {
  zIndex: 2
};
export {
  childElementStyles,
  containerStyles,
  linkWrapperStyles
};
